import React from "react";
import ContentChefMuseo from "../../assets/images/logo.svg";
import classes from "./index.module.scss";

export default function OnboardingLogo() {
  return <img className={classes.OnboardingLogo} src={ContentChefMuseo} alt="contentchef-logo" />;
}
